import { CustomerTransactionTable } from './components/CustomerTransactionTable'

export const CustomerTransactionsPage = () => {
  return (
    <div className="w-full">
      <CustomerTransactionTable />
    </div>
  )
}
